module.exports = __webpack_public_path__ + "7c9665b5b698a65b8f4df7623834e636.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/israel.png
 ** module id = 666
 ** module chunks = 0
 **/